import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=4796ec11&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4796ec11",
  null
  
)

export default component.exports